import { ImageObject } from 'lincd-schema/shapes/ImageObject';
import { getResizedImagePath } from 'lincd-server-utils/utils/ImageResize';
import { QResult } from 'lincd/queries/SelectQuery';
import { cl } from 'lincd/utils/ClassNames';
import { asset } from 'lincd/utils/LinkedFileStorage';
import { replaceLocalhostWithSiteRoot } from 'profile-pics/utils/helper';
import * as React from 'react';
import style from './ConferenceCard.module.css';

//This props probably can be modified in the future
interface ConferenceCardProps {
  id: string;
  name: string;
  buttonText?: string;
  bottomSection?: boolean;
  description?: string;
  image?: QResult<ImageObject, { contentUrl: string }> | null;
  thumbnailWidth?: number;
  thumbnailHeight?: number;
  onClick?: () => void;
  loading?: boolean;
  pinned?: boolean;
  purpleTheme?: boolean;
}

function ConferenceCard({
  name,
  buttonText,
  bottomSection,
  description,
  image,
  thumbnailWidth,
  thumbnailHeight,
  onClick,
  loading,
  pinned,
  purpleTheme,
}: ConferenceCardProps) {
  // change path to use resize image path
  const resolvedImageSrc = replaceLocalhostWithSiteRoot(image?.contentUrl);
  const originalImageSrc = resolvedImageSrc?.startsWith('/')
    ? asset(resolvedImageSrc)
    : resolvedImageSrc;
  const imageSrc = originalImageSrc?.toLowerCase().includes('.svg')
    ? originalImageSrc
    : getResizedImagePath(
        originalImageSrc,
        thumbnailWidth ? thumbnailWidth * 2 : NaN,
        thumbnailHeight ? thumbnailHeight * 2 : thumbnailWidth ? NaN : 300
      );

  // Native button keeps a11y without mui Button "filled" styles, which use
  // --main-color and blend into the dark sign-in background.
  return (
    <button
      type="button"
      className={cl(
        style.MainCard,
        bottomSection && style.withFooter,
        loading && style.disabled,
        purpleTheme && style.purpleTheme
      )}
      onClick={onClick}
      disabled={loading}
      aria-label={description ? `${name}. ${description}` : name}
      data-pinned={pinned || undefined}
    >
      <div className={style.Card}>
        <div className={style.CardImage}>
          {image?.contentUrl && <img src={imageSrc} alt="" />}
        </div>
        <div className={style.HCardContent}>
          <div
            className={cl(
              style.HCardDescription,
              description && style.withDescription
            )}
          >
            <h3>{name}</h3>
            {description ? <p>{description}</p> : null}
          </div>
          <span className={style.HCardButton} aria-hidden="true">
            <img src={asset('/images/icons/ArrowIcon.svg')} alt="" />
            {buttonText ? <p>{buttonText}</p> : null}
          </span>
        </div>
      </div>
    </button>
  );
}

export default ConferenceCard;
